import { DocumentTitle } from 'components/DocumentTitle';
import { DetailsPage } from 'components/page/DetailsPage';
import { AssemblyApplicationParameterDetails } from 'pages/Settings/AssemblyType/AssemblyApplicationParameterDetails';
import { AssemblyTypeDetails } from 'pages/Settings/AssemblyType/AssemblyTypeDetails';
import {
    invalidateAssemblyType,
    useAssemblyType,
} from 'pages/Settings/AssemblyType/useAssemblyType';

export type AssemblyTypeDetailsPageProps = Readonly<{
    assemblyTypeId: number;
}>;

export function AssemblyTypeDetailsPage({
    assemblyTypeId,
}: AssemblyTypeDetailsPageProps) {
    const { data: assemblyType, isLoading, error } = useAssemblyType(assemblyTypeId);

    const onUpdate = () => invalidateAssemblyType(assemblyTypeId);

    return (
        <DetailsPage
            error={error ? 'Unable to load assembly type' : undefined}
            invalidURL={!assemblyType && !isLoading && !!error}
            isLoading={isLoading}
            fullHeight
            fullWidth
        >
            <DocumentTitle
                title={`Assembly Type: ${assemblyType?.Name ?? assemblyType?.Code ?? ''}`}
            />
            {assemblyType && (
                <AssemblyTypeDetails assemblyType={assemblyType} onUpdate={onUpdate} />
            )}
            <AssemblyApplicationParameterDetails assemblyTypeId={assemblyTypeId} />
        </DetailsPage>
    );
}
